import { render, staticRenderFns } from "./lift-detail.vue?vue&type=template&id=2fe03366&"
import script from "./lift-detail.vue?vue&type=script&lang=js&"
export * from "./lift-detail.vue?vue&type=script&lang=js&"
import style0 from "./lift-detail.vue?vue&type=style&index=0&id=2fe03366&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports